export * from './types';
export * from './utils';
import slice from './permissionSlice';

export const {
  setDevPermission,
  setUser,
  updateUserFields,
  updateDefaultSchemaSetting,
} = slice.actions;

export default slice.reducer;
